import { Button, Checkbox, Container, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { AyudantiaInvestigacionData } from "../../interfaces/AYUDANTIAS/Ayudantia"
import AcademicoService from "../../services/AcademicoService";
import AlertService from "../../services/AlertService";
import AyudantiaService from "../../services/AyudantiaService";
import { useState } from "react";
import { MdCheck, MdClose } from "react-icons/md";


interface Props {
  solicitudes: AyudantiaInvestigacionData[],
}

const ayudantiaService = new AyudantiaService();
const alertaService = new AlertService();
const academicoService = new AcademicoService();
function estadoTexto(estado:string):string{
    let texto = '';
    switch(estado){
      case 'P':
        texto = 'Pendiente';
        break;
      case 'A':
        texto = 'Aprobado';
        break;
      case 'N':
        texto = 'Rechazado';
        break;
      case 'X':
        texto = 'Anulada';
        break;
      case 'R':
        texto = 'Reservado-Aprobado';
        break;
      case 'E':
        texto = 'Reservado-Rechazado';
        break;
      case 'G':
        texto = 'Negado-Aprobado';
        break;
      default:
         return '';
    }
    return texto;
  }
export const TableSolicitudAyudDirectivo: React.FC<Props> = ({ solicitudes }) => {

    const [solicitudesAgregadas, setSolicitudesAgregadas] = useState<Array<AyudantiaInvestigacionData>>([]);
    
    const handleCheckSolicitud = (solicitud: AyudantiaInvestigacionData, event: React.ChangeEvent<HTMLInputElement>) => {
    setSolicitudesAgregadas((prevSelected) => 
        event.target.checked
        ? [...prevSelected, solicitud] // Agrega si está checkeado
        : prevSelected.filter(item => item.iddetallesolicitud !== solicitud.iddetallesolicitud) // Quita si se desmarca
    );
    };

    return(
        <Container>
            {
                solicitudesAgregadas.length>0 ?
                <Grid container spacing={1}>
                    <Grid item>
                        <Button size="small"
                            variant="contained"
                            sx={{
                                marginRight: 1, backgroundColor: "#F44336",
                                color: "#FFFFFF !important",
                                "&:hover": { backgroundColor: "#E57373" },
                                boxShadow: 3, margin: "10px"
                            }}
                            
                            endIcon={<MdClose />}
                            //onClick={()=>{handleOpenModalRechazar(solicitudesARechazar)}}
                            >
                            Rechazar todo
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button size="small"
                            variant="contained"
                            sx={{
                            marginRight: 1, backgroundColor: "#4CAF50",
                            color: "#FFFFFF !important",
                            "&:hover": { backgroundColor: "#81C784" },
                            boxShadow: 3, margin: "10px"
                            }}
                            endIcon={<MdCheck />}
                            //onClick={()=>{handleOpenModal(solicitud,"A")}}
                            >
                            Aceptar todo
                        </Button>

                    </Grid>
                </Grid>

                
                
                :null

            }
            
            <TableContainer component={Paper} elevation={3}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#243165" }}>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                {/* <Checkbox /> */}
                            </TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre del proyecto</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre del Ayudante</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Matrícula</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre del Investigador</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Fecha de la solicitud</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Estado</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Impedimento</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Horas otorgadas</TableCell>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {
                            solicitudes.length>0?
                            (
                                solicitudes.map((solicitud, index)=>(
                                    <TableRow key={index}>
                                        <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                            <Checkbox 
                                                onChange={(event) => handleCheckSolicitud(solicitud,event)}
                                            />
                                        </TableCell>
                                        <TableCell>{solicitud.nombreProyecto}</TableCell>
                                        <TableCell>{solicitud.nombreEstudiante}</TableCell>
                                        <TableCell>{solicitud.codestudiante}</TableCell>
                                        <TableCell>{solicitud.nombreInvestigador}</TableCell>
                                        <TableCell>{solicitud.fechasolicitud}</TableCell>
                                        <TableCell>{estadoTexto(solicitud.estadoPaso)}</TableCell>
                                        <TableCell>
                                        {
                                            solicitud.estudianteImpedimentos!='' ?
                                            <ul>
                                            {solicitud.estudianteImpedimentos.split('|').map((est, index) => (
                                                est.trim() !== '' ? <li key={`impedimento-${index}`}>{est}</li> : null
                                            ))}
                                            </ul>
                                            :
                                            <p>-</p>
                                        }
                                        </TableCell>
                                        <TableCell>{solicitud.horasOtorgadas}</TableCell>

                                    </TableRow>
                                ))
                            )
                            
                            :
                            (
                                <TableRow>
                                    <TableCell colSpan={9} align="center">
                                        No hay solicitudes registradas.
                                    </TableCell>
                                </TableRow>
                            )
                            
                        }

                    </TableBody>
                    
                </Table>
            </TableContainer>
        </Container>
    )
}